import React from 'react';
import AvatarIcon from '@/assets/icons/avatar.svg';
import ArrowsCounterClockwiseIcon from '@/assets/icons/arrows-counter-clockwise.svg';
import UnionIcon from '@/assets/icons/union.svg';
import UnregisterGrayIcon from '@/assets/icons/unregister-gray.svg';
import TimerEditIcon from '@/assets/icons/timer-edit.svg';
interface Subscriber {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
}

interface SubscriberItemProps {
  item: Subscriber;
  onChangeSubscription: (id: string) => void;
  onSuspend: (id: string) => void;
  onItemClick: (id: string) => void;
  onUnregister?: (id: string) => void;
}

const SubscriberItem: React.FC<SubscriberItemProps> = ({
  item,
  onChangeSubscription,
  onSuspend,
  onItemClick,
  onUnregister
}) => {
  const name = `${item?.firstName || ''} ${item?.lastName || ''}`;

  const itemActions = () => {
    switch (item.status) {
      case 'ACTIVE':
        return (
          <>
            {/* <button
              className="w-8 h-8 rounded-[6px] border border-[#93999F] flex items-center justify-center cursor-pointer hover:bg-secondary/50"
              onClick={(e) => {
                e.stopPropagation();
                onChangeSubscription(item.id);
              }}
              title="Change Subscription"
            >
              <img src={ArrowsCounterClockwiseIcon} alt="arrows-counter-clockwise" />
            </button> */}
            <button
              className="w-8 h-8 rounded-[6px] border border-[#93999F] flex items-center justify-center cursor-pointer hover:bg-secondary/50"
              onClick={(e) => {
                e.stopPropagation();
                onSuspend(item.id);
              }}
              title="Suspend"
            >
              <img src={UnionIcon} alt="union" />
            </button>
          </>
        );
      case 'UNREGISTERED':
        return (
          <button
            className="w-8 h-8 rounded-[6px] border border-[#93999F] flex items-center justify-center cursor-pointer hover:bg-secondary/50"
            onClick={(e) => {
              e.stopPropagation();
              onUnregister?.(item.id);
            }}
            title="Unregister"
          >
            <img src={UnregisterGrayIcon} alt="unregistered-gray" />
          </button>
        );
      case 'BANNED':
        return (
          <button
            className="w-8 h-8 rounded-[6px] border border-[#93999F] flex items-center justify-center cursor-pointer hover:bg-secondary/50"
            onClick={(e) => {
              e.stopPropagation();
              onSuspend?.(item.id);
            }}
          >
            <img src={TimerEditIcon} alt="timer-edit" />
          </button>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="w-full flex items-center justify-between gap-4 cursor-pointer hover:bg-secondary/50"
      onClick={() => onItemClick(item.id)}
    >
      {/* left */}
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <img src={AvatarIcon} alt="avatar" className="flex-shrink-0" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold leading-[150%] truncate">{name}</p>
          <span className="text-xs text-secondary font-medium leading-[100%] truncate block">{item.email}</span>
        </div>
      </div>

      {/* right */}
      <div className="flex items-center gap-4">{itemActions()}</div>
    </div>
  );
};

export default SubscriberItem;
